import { type FC, useMemo } from "react";
import { SimpleSelect } from "~/common/components/Select/SimpleSelect";
import Parameter from "~/common/components/Parameter";
import { useTranslation } from "react-i18next";
import { getOrderType } from "~/utils/language/translationUtils";

interface Props {
  availableOrderTypes: string[];
  value: string;
  onChange?: (event: any) => void;
}

const OrderTypeSelection: FC<Props> = ({ availableOrderTypes, value, onChange }) => {
  const { t } = useTranslation();
  const dropdownEntries = useMemo(() => {
    return availableOrderTypes.map((code) => ({
      value: code,
      label: getOrderType(t, code),
    }));
  }, [availableOrderTypes]);

  let valueDisplayElement;
  if (dropdownEntries.length > 1) {
    valueDisplayElement = (
      <SimpleSelect
        values={dropdownEntries}
        value={value}
        onChange={onChange}
        fullWidth={true}
        data-test-id={"order-type-dropdown"}
        label={t("header.selectedOrderType")}
      />
    );
  } else {
    const label = getOrderType(t, value);
    valueDisplayElement = (
      <Parameter label={t("header.selectedOrderType")}>
        <span title={label} className={"title-medium scha__ellipsis-text"}>
          {label}
        </span>
      </Parameter>
    );
  }

  return (
    <div className={"scha__checkout__order-type"}>
      {/* SCHAEFF-12700 - Temporary removal of truck icon */}
      {/*<HeaderCircle className={"mr-2"}>*/}
      {/*  <Icon type={IconType.TRUCK} size={IconSize.FONT_25} />*/}
      {/*</HeaderCircle>*/}
      <div className={"scha__checkout__order-type__data"}>{valueDisplayElement}</div>
    </div>
  );
};
export default OrderTypeSelection;
